//二次开发接口

import { base, baseGateway } from "./base"; // 导入接口域名列表
import axios from "@/utils/http"; // 导入http中创建的axios实例

const twice = {
  // 客户端结算管理 列表
  postStatementStatementList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/statement/statementList`,
      params
    );
  },
  // 客户端结算管理 结算单详情
  postStatementStatementDetailInfo(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/statement/statementDetailInfo?statementNo=${params}`
    );
  },

  // // 客户端异议列表
  // postClientDisputeList(params) {
  //     return axios.post(`${base()}/chem-ctm-on/ksDispute/client/DisputeList`, params);
  // },

  // 供应商端异议列表
  postSupplierDisputeList(params) {
    return axios.post(
      `${base()}/chem-ctm-on/ksDispute/supplier/DisputeList`,
      params
    );
  },

  // 供应商  客商采购询单转交
  postInquiryInquiryGive(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-rfq/inquiry/inquiryGive`,
      params
    );
  },
  // 供应商  询单转交 列表
  getUserSeachpostUser(params) {
    return axios.get(
      `${base()}/uam-web/api/user/seachpostUser?appCode=HGB&companyCode=${params}&model-key=rfq`
    );
  },
  // 供应商  客商采购询单数量统计
  getInquiryMyInquiryNum(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-rfq/inquiry/myInquiryNum?stuffType=${params}`
    );
  },
  // 供应商  客商采购询单列表
  postInquiryTable(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-rfq/inquiry/table`,
      params
    );
  },
  // 供应商  客商工作台参与的询单列表
  postWorkbenchJoinInquiry(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-rfq/inquiry/workbench/joinInquiry`,
      params
    );
  },

  // 查看合同
  getContractOneSelectByFile(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/contractOne/selectByFilePDF?contractCode=${
        params.contractCode
      }&revNo=${params.revNo}`,
      { responseType: "blob" }
    );
  },

  // 根据客商一体化登录信息令牌获取客商一体化登录信息
  getKsythLoginInfo(tokenKey) {
    return axios.get(`${base()}/sso-web/ksyth-login-info/${tokenKey}`);
  },

  // 客户异议列表
  postKsDisputeList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm-on/ksDispute/list`,
      params
    );
  },
  // 客户异议  提单列表
  postKsDisputeBillLadingList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm-on/ksDispute/billLadingList`,
      params
    );
  },
  // 文件上传
  postKsDisputeFileUpload(data, params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm-on/ksDispute/fileUpload?companyCode=${
        data.companyCode
      }`,
      params,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },
  // 查看异议信息
  getKsDisputeInfo(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm-on/ksDispute/info?id=${params}`
    );
  },
  // 保存异议信息
  postKsDisputeSave(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm-on/ksDispute/save`,
      params
    );
  },

  //客户工作台提单 查询提单是否绑定质保书
  getExtractFromIsBinding(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractFrom/isBinding?billLadingNum=${
        params.billLadingNum
      }`
    );
  },
  //客户工作台提单 下载质保书
  getExtractFromDownloadWarranty(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractFrom/downloadWarranty?billLadingNum=${
        params.billLadingNum
      }`
    );
  },

  //客户工作台提单 提货单导出
  postExtractFromExportExtractFrom(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractFrom/exportExtractFrom`,
      params,
      { responseType: "arraybuffer" }
    );
  },

  //客户工作台提单 批量导出磅单
  postPondDownloadBatchPond(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/pond/downloadBatchPond`,
      params,
      { responseType: "arraybuffer" }
    );
  },
  //客户工作台提单 磅单是否可导出
  getPondIsExport(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/pond/isExport?billLadingNum=${
        params.billLadingNum
      }`
    );
  },
  //客户工作台提单 下载单个磅单
  getPondDownloadSinglePond(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/pond/downloadSinglePond?billLadingNum=${
        params.billLadingNum
      }`,
      { responseType: "arraybuffer" }
    );
  },

  //动态生成CA软证书申请书
  postContractOneDownloadPdf(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/contractOne/downloadPdf`,
      params,
      { responseType: "arraybuffer" }
    );
  },

  // 获取令牌
  postGetToken(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/location/getToken`,
      params
    );
  },
  // 客商发起轨迹查询
  postToCarTrack(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/location/toCarTrack`,
      params
    );
  },
  // 车辆轨迹查询
  postVehicleTrack(params) {
    return axios.post(
      `https://bwty.b-chem.com/chem-gateway/chem-loms/location/vehicleTrack`,
      params
    );
  },
  // 可查询轨迹次数
  getQueryTimes() {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/location/queryTimes`
    );
  },

  // 支付 支付宝
  // 添加会员订单信息
  postAddMemberInfo(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/member/addMemberInfo`,
      params
    );
  },
  // 获取供应商信息
  getProviderInfo() {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/member/providerInfo`
    );
  },

  // 金融授信
  // 查询授信账户信息
  getQueryCreditAccount() {
    return axios.get(
      `${base()}/chem-interface-web/applet/credit/client/queryCreditAccount`
    );
  },
  //查询用户的授信额度
  postQueryCreditBaseInfo(params) {
    return axios.post(
      `${base()}/chem-interface-web/applet/credit/order/queryCreditBaseInfo`,
      params
    );
  },
  // 查询收款方信息
  // getCreditClientPayInfo(data) {
  //   return axios.get(`${base()}/chem-interface-web/applet/credit/client/payInfo?supplierCode=${data}`);
  // },
  getCreditClientPayInfo(params) {
    return axios.get(
      `${base()}/chem-interface-web/api/getBankList/${params.companyCode}`
    );
  },

  //申请白条支付
  // postWhiteSlipPayment(params) {
  //   return axios.post(`${base()}/chem-interface-web/applet/credit/client/whiteSlipPayment`, params);
  // },
  postWhiteSlipPayment(params) {
    return axios.post(
      `${base()}/chem-interface-web/api/xcx/whiteSlipPayment`,
      params
    );
  },

  // 登记对方量同步至一体化
  postRegisterOtherMount(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalFrom/registerOtherMount`,
      params
    );
  },
  // 登记对方量同步至一体化  修改到货单对方量
  postUpdateOtherWeight(params) {
    return axios.patch(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/updateOtherWeight`,
      params
    );
  },

  // 提货管理(炭黑) --***********************************************************************************
  // 提单列表查询
  postBillBillLadingList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bill/billLadingList`,
      params
    );
  },
  // 提单详情查询
  getBillBillLadingDetail(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/bill/billLadingDetail?sendPlanNum=${params}`
    );
  },
  // 提货派车申请(修改)
  postBillDeliveryReq(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bill/deliveryReq`,
      params
    );
  },
  // 送货回单上传
  postBillArrivalFormUpload(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bill/arrivalFormUpload`,
      params
    );
  },

  // 查询车辆详情
  getCarrierCarCarDetail(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/carDetail?licensePlate=${params}`
    );
  },
};
export default twice;
